import React, { useState } from 'react';

import { Input } from '@eika/input';

import useTranslation, { format } from '../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from './form/actions';
import useFormContext from './form/useFormContext';

interface Props {
    resetError: () => void;
    error?: string;
}

const MAX_CREDITOR_MESSAGE = 140;

const MessageReceiverField: React.FC<Props> = ({ resetError, error }) => {
    const translated = useTranslation();
    const [maxLengthError, setMaxLengthError] = useState<string>();
    const { state, handleChange } = useFormContext();
    return (
        <Input
            className="description-cross-border-payment__message"
            label={translated.crossBorderPayment.description.messageLabel}
            value={state.messageReceiver}
            onChange={(event) => {
                handleChange({ type: CrossBorderPaymentActionType.MESSAGE_RECEIVER, payload: event.target.value });
                resetError();
                if (event.target.value.length === MAX_CREDITOR_MESSAGE) {
                    setMaxLengthError(format(translated.tooManyCharacters, MAX_CREDITOR_MESSAGE));
                } else {
                    setMaxLengthError(undefined);
                }
            }}
            maxLength={MAX_CREDITOR_MESSAGE}
            error={error ?? maxLengthError}
            data-testid="cross-border-description-message"
        />
    );
};

export default MessageReceiverField;
